// src/store/settings/selectors.js
export const selectSettings = s => s.settings

export const selectFPS = s => s.settings.fps

export const selectChannel = s => s.settings.channel

export const selectUsePixi = s => s.settings.use_pixi

export const selectFlipH = s => s.settings.flip_h

export const selectFlipV = s => s.settings.flip_v

export const selectMicrophoneEnabled = s => s.settings.microphone_enabled ?? true

export const selectKeepCamerasArmed = s => s.settings.keep_cameras_armed ?? true

export const selectPresetIndexPrefix = s => !!s.settings.preset_index_prefix

export const selectShowExamplePresets = s => s.settings.show_example_presets ?? true
